import React from "react";
import PageSerch from "./SerchDocters/Components/PageSerch";
import DynamicBreadcrumbs from "../../Uitiles/DynamicBreadcrumbs";
import { oneKlicks } from "../../SDK/oneclick";
import { toast } from "react-toastify";
import GoogleLocation from "../../components/GoogleLocation";

const Contactus = () => {
    const [formData, setFormData] = React.useState({
        name: "",
        email: "",
        message: ""
    });
    const [formErrors, setFormErrors] = React.useState({});
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [selectedLocation, setSelectedLocation] = React.useState({
        lat: 17.3850,  // Hyderabad coordinates
        lng: 78.4867
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        setIsSubmitting(true);
        setFormErrors({});

        // Validate form data
        const errors = {};
        if (!formData.name.trim()) {
            errors.name = "Name is required";
        }
        if (!formData.email.trim()) {
            errors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = "Email is invalid";
        }
        if (!formData.message.trim()) {
            errors.message = "Message is required";
        } else if (formData.message.length < 10) {
            errors.message = "Message must be at least 10 characters long";
        } else if (formData.message.length > 500) {
            errors.message = "Message must be less than 500 characters";
        }

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            setIsSubmitting(false);
            return;
        }

        try {
            const tableSchema = "";
            const tableName = "contactus";
            const conditions = {};
            const data = {
                name: formData.name,
                email: formData.email,
                message: formData.message,
                read: 0,
                status: 0,
            };
            const response = await oneKlicks.create(tableSchema, tableName, data, conditions);

            console.log("Response from create:", response);

            if (response.success === true) {
                console.log("Form submitted successfully:", response.message);
                setFormData({ name: "", email: "", message: "" });
                toast.success("Form submitted successfully!");
                setFormErrors({});
            } else {
                throw new Error("Failed to submit form");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("Failed to submit the form. Please try again.");
            setFormErrors({ submit: "Failed to submit the form. Please try again." });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleLocationSelect = (location) => {
        setSelectedLocation(location);
    };

    return (
        <div>
            <PageSerch />
            <DynamicBreadcrumbs />
            <section className="elementor-section elementor-top-section elementor-element elementor-element-b55fd66 elementor-section-stretched elementor-section-full_width elementor-section-height-default" data-id="b55fd66" data-element_type="section">
                <div className="elementor-container elementor-column-gap-no">
                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6d82cca" data-id="6d82cca" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-fa1444e elementor-widget elementor-widget-dc_element_easy_steps" data-id="fa1444e" data-element_type="widget">
                                <div className="elementor-widget-container">
                                    <div className="dc-aboutstep dc-easy-steps dc-haslayout dynamic-secton-240460">
                                        <div className="container">
                                            <div className="row justify-content-center align-self-center">
                                                <div className="col-xs-12 col-sm-12 col-md-8 push-md-2 col-lg-8 push-lg-2">
                                                    <div className="dc-sectionhead dc-text-center">
                                                        <div className="dc-sectiontitle">
                                                            <h2>
                                                                <span>Always Get In Touch</span>
                                                                We're Ready To <em>Serve You</em>
                                                            </h2>
                                                        </div>
                                                        <div className="dc-description">
                                                            <p>Have any questions or need assistance? Our team is always here to help. Reach out to us anytime!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="dc-welcome-holder dc-bksteps">
                                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-left">
                                                    <div className="dc-welcomecontent">
                                                        <figure className="dc-welcomeimg">
                                                            <img src="//amentotech.com/projects/doctreat/wp-content/uploads/2019/08/img-01-1.jpg" alt="Have Query? Contact Us" />
                                                        </figure>
                                                        <div className="dc-title">
                                                            <h3><span>Have Query? Contact Us</span>+91 9705656070</h3>
                                                        </div>
                                                        <div className="dc-description">
                                                            <p>We're here to assist you. Get in touch for any inquiries or support!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-left">
                                                    <div className="dc-welcomecontent">
                                                        <figure className="dc-welcomeimg">
                                                            <img src="//amentotech.com/projects/doctreat/wp-content/uploads/2019/08/img-02-1.jpg" alt="Drop Us A Line" />
                                                        </figure>
                                                        <div className="dc-title">
                                                            <h3><span>Drop Us A Line</span>info@meddylist.com</h3>
                                                        </div>
                                                        <div className="dc-description">
                                                            <p>We're here to assist you. Feel free to reach out for any inquiries or support!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-left">
                                                    <div className="dc-welcomecontent">
                                                        <figure className="dc-welcomeimg">
                                                            <img src="//amentotech.com/projects/doctreat/wp-content/uploads/2019/08/img-03.jpg" alt="Come & Meet Us" />
                                                        </figure>
                                                        <div className="dc-title">
                                                            <h3><span>Come & Meet Us</span>2-19-76, plot no.169, Kalyanpuri Colony Rd, Uppal, Hyderabad, Telangana 500039</h3>
                                                        </div>
                                                        <div className="dc-description">
                                                            <p>Visit us at our office for any assistance. We're always happy to help!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="elementor-section elementor-top-section elementor-element elementor-element-ea4ab33 elementor-section-stretched elementor-section-boxed elementor-section-height-default" data-id="ea4ab33" data-element_type="section" style={{ backgroundImage: 'url(//css.meddylist.com//wp-content/uploads/2019/08/banner-img.png)' }}>
                <div className="elementor-container elementor-column-gap-no">
                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4056f06" data-id="4056f06" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-414fe89 elementor-widget elementor-widget-dc_element_online_help" data-id="414fe89" data-element_type="widget">
                                <div className="elementor-widget-container">
                                    <div className="text-center dc-querycontent dynamic-secton-409066">
                                        <div className="container">
                                            <div className="row justify-content-center">
                                                <div className="col-12 col-sm-12 col-md-12 col-lg-8">
                                                    <div className="dc-sectionhead dc-sectionheadvtwo">
                                                        <div className="dc-sectiontitle">
                                                            <h2>
                                                                Have A Query?
                                                                <span>Ask For Free Online Help</span>
                                                            </h2>
                                                        </div>
                                                        <div className="dc-description">
                                                            <p>Need expert advice or answers to your questions? Our team is here to assist you. Get reliable support anytime!</p>
                                                        </div>
                                                    </div>
                                                    <div className="dc-btnarea d-flex justify-content-center">
                                                        <a href="//css.meddylist.com//health-forum/" className="dc-btn dc-btnactive">View Question</a>
                                                        <a href="//css.meddylist.com//health-forum/mouth-open-while-sleeping/" className="ajax-load dc-btn">Ask Your Question</a>
                                                    </div>
                                                    <figure className="dc-queryimg">
                                                        <img src="//amentotech.com/projects/doctreat/wp-content/uploads/2019/08/phoneagain.png" alt="Contact Support" />
                                                    </figure>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="elementor-section elementor-top-section elementor-element elementor-section-boxed elementor-section-height-default">
                <div className="elementor-container elementor-column-gap-extended">
                    <div className="elementor-column elementor-col-100 elementor-top-column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-widget">
                                <div className="elementor-widget-container">
                                    <div className="dc-sectionhead dc-text-center">
                                        <div className="dc-sectiontitle">
                                            <h2>
                                                <span>Our Location</span>
                                                Find <em>Us Here</em>
                                            </h2>
                                        </div>
                                        <div className="dc-description">
                                            <p>Visit us at our office location. We're here to help you!</p>
                                        </div>
                                    </div>
                                    <div className="dc-location-map" style={{ marginTop: '30px' }}>
                                        <GoogleLocation onLocationSelect={handleLocationSelect} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="elementor-section elementor-top-section elementor-element elementor-element-d43cf57 elementor-section-stretched elementor-section-boxed elementor-section-height-default" data-id="d43cf57" data-element_type="section">
                <div className="elementor-container elementor-column-gap-extended">
                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f6eabc3" data-id="f6eabc3" data-element_type="column">
                        <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-048bc41 elementor-widget elementor-widget-dc_element_contact_us_form" data-id="048bc41" data-element_type="widget">
                                <div className="elementor-widget-container">
                                    <div className="dc-haslayout-v1 dc contact-form">
                                        <div className="row justify-content-center dynamic-secton-703847">
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-8">
                                                <div className="dc-sectionhead dc-text-center dc-pnone">
                                                    <div className="dc-sectiontitle">
                                                        <h2>
                                                            <span>Get In Touch With Us</span>
                                                            Say <em>Hello To Us</em>
                                                        </h2>
                                                    </div>
                                                    <div className="dc-description">
                                                        <p>Have questions or need assistance? We're here to help! Feel free to reach out for expert support and guidance.</p>
                                                    </div>
                                                </div>
                                                <div className="dc-form dc-floatclear dc-form-first">
                                                    <form onSubmit={handleFormSubmit} className="wpcf7-form init" aria-label="Contact form">
                                                        <div className="form-row">
                                                            <div className="form-group col-12 col-sm-6">
                                                                <p>
                                                                    <input
                                                                        type="text"
                                                                        name="name"
                                                                        value={formData.name}
                                                                        onChange={handleInputChange}
                                                                        className={`wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-control ${formErrors.name ? 'is-invalid' : ''}`}
                                                                        placeholder="Your Name*"
                                                                        required
                                                                    />
                                                                    {formErrors.name && <div className="invalid-feedback">{formErrors.name}</div>}
                                                                </p>
                                                            </div>
                                                            <div className="form-group col-12 col-sm-6">
                                                                <p>
                                                                    <input
                                                                        type="email"
                                                                        name="email"
                                                                        value={formData.email}
                                                                        onChange={handleInputChange}
                                                                        className={`wpcf7-form-control wpcf7-email wpcf7-validates-as-required form-control ${formErrors.email ? 'is-invalid' : ''}`}
                                                                        placeholder="Your Email*"
                                                                        required
                                                                    />
                                                                    {formErrors.email && <div className="invalid-feedback">{formErrors.email}</div>}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <p>
                                                                <textarea
                                                                    name="message"
                                                                    value={formData.message}
                                                                    onChange={handleInputChange}
                                                                    className={`wpcf7-form-control wpcf7-textarea wpcf7-validates-as-required form-control ${formErrors.message ? 'is-invalid' : ''}`}
                                                                    placeholder="Type Your Query*"
                                                                    required
                                                                />
                                                                {formErrors.message && <div className="invalid-feedback">{formErrors.message}</div>}
                                                            </p>
                                                        </div>
                                                        <p>
                                                            <button
                                                                type="submit"
                                                                className="wpcf7-form-control wpcf7-submit has-spinner btn dc-btns btn-block dc-btnactive"
                                                                disabled={isSubmitting}
                                                            >
                                                                {isSubmitting ? 'Sending...' : 'Send Now'}
                                                            </button>
                                                        </p>
                                                        {formErrors.submit && (
                                                            <div className="alert alert-danger mt-3">
                                                                {formErrors.submit}
                                                            </div>
                                                        )}
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contactus;
